import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {AnswerCompleteness} from '../../rfi-individual-results.calc';
import {RfiAnswerCompletenessComponent} from '../../parts/rfi-answer-completeness/rfi-answer-completeness.component';
import {RfiMetricGridComponent} from '../../parts/rfi-metric-grid/rfi-metric-grid.component';
import {ScoreBarComponent} from '../../../score-bar/score-bar.component';
import {EmployeeBreakdownPart, MetricCard} from '../../rfi-individual-results-modal.types';

@Component({
  selector: 'app-rfi-company-section',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AppNumberPipe,
    TranslocoPipe,
    RfiAnswerCompletenessComponent,
    RfiMetricGridComponent,
    ScoreBarComponent,
  ],
  host: {class: 'flex flex-col gap-4'},
  templateUrl: './rfi-company-section.component.html',
})
export class RfiCompanySectionComponent {
  readonly completeness = input.required<AnswerCompleteness>();
  readonly cards = input.required<MetricCard[]>();
  readonly employeeBreakdown = input.required<EmployeeBreakdownPart[]>();
}
